<template>
  <div>
    <div class="contents">
      <b-form @submit="onSubmit">
        <div class="row g-0 table-type header-col">
          <div class="col-sm-4">
            {{ $t("title.common.title") }}
          </div>
          <div class="col-sm-8">
            <input
              type="text"
              :placeholder="
                $t('title.common.minigame') + $t('title.common.title')
              "
              name="title"
              required
              v-model="form.title"
            />
          </div>

          <div class="col-sm-4">
            {{ $t("title.event.message") }}
          </div>
          <div class="col-sm-8">
            <input
              type="text"
              :placeholder="$t('title.event.message')"
              name="message"
              required
              v-model="form.message"
            />
          </div>

          <div class="col-sm-4">
            {{ $t("title.event.success_message") }}
          </div>
          <div class="col-sm-8">
            <input
              type="text"
              :placeholder="$t('title.event.success_message')"
              name="successmessage"
              required
              v-model="form.successmessage"
            />
          </div>

          <div class="col-sm-4">
            {{ $t("title.common.date") }}
          </div>
          <div class="col-sm-8 d-block">
            <div class="row row-cols-1 row-cols-sm-2 g-2">
              <div class="col">
                <input
                  type="date"
                  class="form-control-lg"
                  required
                  v-model="form.startdate"
                />
              </div>
              <div class="col">
                <input
                  type="date"
                  class="form-control-lg"
                  required
                  v-model="form.enddate"
                />
              </div>
            </div>
          </div>

          <div class="col-sm-4">
            {{ $t("title.event.system_range") }}
          </div>
          <div class="col-sm-8">
            <select class="form-select-lg" v-model="form.systemrange">
              <option value="0">{{ $t("filter.common.total") }}</option>
            </select>
          </div>
          <!-- <div class="col-sm-4">
            {{ $t("title.common.minigame") }} {{ $t("title.common.type") }}
          </div>
          <div class="col-sm-8">
            <div class="input-group">
              <select v-model="form.awardtype" class="form-select">
                <option value="1">
                  {{ $t("filter.tournament.public") }}
                </option>
                <option value="2">
                  {{ $t("filter.tournament.invitation") }}
                </option>
              </select>
              <button
                v-if="form.awardtype == '2'"
                type="button"
                class="btn btn-primary btn-lg"
                @click="invitational_modal"
              >
                {{ $t("button.tournament.invitation") }}
              </button>
            </div>
          </div> -->
          <div class="col-sm-4">
            {{ $t("title.common.entry_limit") }}
          </div>
          <div class="col-sm-8 d-block">
            <input
              type="text"
              v-model="form.entrylimit"
              placeholder="Entry Limit"
              class="text-red"
            />
            <p class="text-subscript mt-2">
              {{ $t("text.common.entry_limit") }}
            </p>
          </div>

          <div class="col-sm-4">
            {{ $t("title.common.type") }}
          </div>
          <div class="col-sm-8">
            <select
              class="form-select-lg"
              v-model="form.type"
              @change="change_type()"
            >
              <option value="0">{{ $t("title.common.select") }}</option>
              <option value="1">{{ $t("filter.event.holeinone") }}</option>
              <option value="2">{{ $t("filter.event.albatross") }}</option>
              <option value="3">{{ $t("filter.event.eagle_p5") }}</option>
              <option value="4">{{ $t("filter.event.birdie_p5") }}</option>
              <option value="5">{{ $t("filter.event.par_p5") }}</option>
              <option value="6">{{ $t("filter.event.eagle_p4") }}</option>
              <option value="7">{{ $t("filter.event.birdie_p4") }}</option>
              <option value="8">{{ $t("filter.event.par_p4") }}</option>
              <option value="9">{{ $t("filter.event.longest") }}</option>
              <option value="10">{{ $t("filter.event.nearpin") }}</option>
              <option value="11">
                {{ $t("filter.event.longest_rank") }}
              </option>
              <option value="12">
                {{ $t("filter.event.nearpin_rank") }}
              </option>
            </select>
          </div>
          <template v-if="form.type == '9' || form.type == '10'">
            <div class="col-sm-4">
              {{ $t("title.common.distance") }}
            </div>

            <div class="col-sm-8 d-block">
              <input
                type="text"
                name="distance"
                required
                v-model="form.distance"
              />
              <p class="text-subscript mt-2">
                {{ $t("text.common.value_greater_than_0") }}
              </p>
            </div>
          </template>

          <template v-if="form.type == '11' || form.type == '12'">
            <div class="col-sm-4">
              {{ $t("title.event.prize_rank") }}
            </div>
            <div class="col-sm-8 d-block">
              <select
                class="form-select-lg"
                v-model="form.rankno"
                @change="form.rankprizelist = []"
              >
                <template v-for="(rank, index) in rank_count">
                  <option :key="index + 'r'" :value="rank">{{ rank }}</option>
                </template>
              </select>
              <p class="text-subscript mt-2">
                {{ $t("text.common.prize_rank") }}
              </p>
            </div>

            <div class="col-sm-4">
              {{ $t("title.common.prizes") }}
            </div>
            <div class="col-sm-8">
              <div
                class="row row-cols-1 row-cols-md-2 row-cols-xl-3 gx-2 gy-3 flex-fill"
              >
                <template v-for="(rank, index) in form.rankno">
                  <div
                    class="col"
                    v-if="form.rankno >= rank"
                    :key="index + 'rp'"
                  >
                    <h6 class="mb-2 fs-13 fw-500">
                      {{ $t("title.common.top_rank") }}{{ rank }}
                    </h6>
                    <input
                      type="text"
                      class="text-prize"
                      :name="'rankprize' + rank"
                      v-model="form.rankprizelist[index]"
                    />
                  </div>
                </template>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="col-sm-4">
              {{ $t("title.common.prizes") }}
            </div>
            <div class="col-sm-8">
              <input
                type="text"
                class="text-prize"
                required
                v-model="form.point"
              />
            </div>
          </template>

          <div class="col-sm-4">
            {{ $t("title.common.oom_point") }}
          </div>
          <div class="col-sm-8 d-block">
            <b-form-checkbox
              v-model="form.oom_point"
              name="check-button"
              size="lg"
              switch
            >
            </b-form-checkbox>
          </div>

          <div class="col-sm-4">
            {{ $t("title.common.standard_point") }}
          </div>
          <div class="col-sm-8 d-block">
            <b-form-checkbox
              v-model="form.standard_point"
              name="check-button"
              size="lg"
              switch
            >
            </b-form-checkbox>
          </div>



          <div class="col-sm-4">
            {{ $t("title.common.course") }}
          </div>
          <div class="col-sm-8">
            <select
              class="form-select-lg"
              v-model="form.courseno"
              @change="change_cc()"
            >
              <option value="">
                {{ $t("filter.common.select_golfcourse") }}
              </option>
              <template v-for="(cc, index) in eventcourselist">
                <option :key="index" :value="cc.maincourseno">
                  {{ cc.coursename }}
                </option>
              </template>
            </select>
          </div>

          <template v-if="courseview_yn === 'y'">
            <div class="col-sm-4">
              {{ $t("title.common.subcourse") }}
            </div>
            <div class="col-sm-8 d-block">
              <!-- Sub Course -->
              <div
                v-for="(anc, index1) in courseview.subcourse"
                :key="index1"
                class="table-sticky-columns"
              >
                <p class="info">
                  {{ $t("title.common.subcourse") }} {{ anc.subcourseseq }} [{{
                    anc.title
                  }}]
                </p>
                <div class="position-relative">
                  <table class="table table-sticky-header">
                    <thead>
                      <tr class="bg-lightgray">
                        <th>{{ $t("title.common.hole") }}</th>
                      </tr>
                      <tr class="bg-lightgray">
                        <th>{{ $t("title.common.par") }}</th>
                      </tr>
                      <tr class="bg-lightgray">
                        <th>{{ $t("title.common.distance") }}</th>
                      </tr>
                      <tr class="bg-lightgray">
                        <th class="border-bottom-0 text-capitalize">
                          {{ $t("text.common.choice") }}
                        </th>
                      </tr>
                    </thead>
                  </table>
                  <div class="fix-table">
                    <table class="table">
                      <tbody>
                        <tr>
                          <template v-for="(oc, index2) in anc.subcoursehole">
                            <td
                              :key="index2 + 'o'"
                              class="fw-500 text-black bg-lightgray"
                            >
                              {{ oc.hole_no }}
                            </td>
                          </template>
                        </tr>
                        <tr>
                          <template v-for="(oc, index3) in anc.subcoursehole">
                            <td :key="index3 + 'op'">{{ oc.par_score }}</td>
                          </template>
                        </tr>
                        <tr>
                          <template v-for="(oc, index4) in anc.subcoursehole">
                            <td :key="index4 + 'od'">{{ oc.distance }}</td>
                          </template>
                        </tr>
                        <tr>
                          <template v-for="(oc, index5) in anc.subcoursehole">
                            <td :key="index5 + 'oc'">
                              <input
                                type="radio"
                                class="form-check-input custom-checkbox m-0"
                                :value="oc.hole_no + '_' + anc.subcourseseq"
                                v-model="form.hole"
                                @click="click_hole"
                              />
                            </td>
                          </template>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <!-- // Sub Course -->
            </div>
          </template>

          <div class="col-sm-4">
            {{ $t("title.common.hole") }}
          </div>
          <div class="col-sm-8 py-4">
            <p v-if="form.hole">
              {{ $t("title.common.subcourse") }}
              {{
                courseview.subcourse.find(
                  (v) => v.subcourseseq == form.hole.split("_").pop()
                ) &&
                courseview.subcourse.find(
                  (v) => v.subcourseseq == form.hole.split("_").pop()
                ).title
              }}
              {{ form.hole.split("_").shift() }}
              {{ $t("title.common.hole") }}({{ $t("title.common.par") }}
              {{
                courseview.subcourse.find(
                  (v) => v.subcourseseq == form.hole.split("_").pop()
                ) &&
                courseview.subcourse
                  .find((v) => v.subcourseseq == form.hole.split("_").pop())
                  .subcoursehole.find(
                    (v) => v.hole_no == form.hole.split("_").shift()
                  ).par_score
              }})
            </p>
          </div>

          <div class="col-sm-4">
            {{ $t("title.event.teebox") }}
          </div>
          <div class="col-sm-8 d-block">
            <div class="row row-cols-1 g-2">
              <div class="col">
                <select class="form-select-lg" v-model="form.isteebox">
                  <option value="0">
                    {{ $t("filter.common.not_in_use") }}
                  </option>
                  <option value="1">
                    {{ $t("filter.common.use") }}
                  </option>
                </select>
              </div>

              <div class="col" v-if="form.isteebox == '1'">
                <div class="row row-cols-1 row-cols-sm-2 g-2">
                  <div class="col">
                    <select class="form-select-lg" v-model="form.teeboxman">
                      <option value="0">
                        {{ $t("title.tournament.teebox_male") }}
                      </option>
                      <option value="1">
                        <!-- {{ $t("text.common.pro") }} -->
                        {{ $t("text.common.blue") }}
                      </option>
                      <option value="2">
                        <!-- {{ $t("text.common.regular") }} -->
                        {{ $t("text.common.white") }}
                      </option>
                      <option value="3">
                        <!-- {{ $t("text.common.lady") }} -->
                        {{ $t("text.common.red") }}
                      </option>
                      <option value="3">
                        <!-- {{ $t("text.common.senior") }} -->
                        {{ $t("text.common.yellow") }}
                      </option>
                    </select>
                  </div>
                  <div class="col">
                    <select class="form-select-lg" v-model="form.teeboxwoman">
                      <option value="0">
                        {{ $t("title.tournament.teebox_female") }}
                      </option>
                      <option value="1">
                        <!-- {{ $t("text.common.pro") }} -->
                        {{ $t("text.common.blue") }}
                      </option>
                      <option value="2">
                        <!-- {{ $t("text.common.regular") }} -->
                        {{ $t("text.common.white") }}
                      </option>
                      <option value="3">
                        <!-- {{ $t("text.common.lady") }} -->
                        {{ $t("text.common.red") }}
                      </option>
                      <option value="3">
                        <!-- {{ $t("text.common.senior") }} -->
                        {{ $t("text.common.yellow") }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--
          <div class="col-sm-4">
            {{
              $t("title.common.gender")
            }}
          </div>
          <div class="col-sm-8">
            <select class="form-select-lg" v-model="form.gender">
              <option value="0">{{ $t("filter.common.total") }}</option>
              <option value="M">{{ $t("filter.common.male") }}</option>
              <option value="F">{{ $t("filter.common.female") }}</option>
            </select>
          </div>
          -->

          <div class="col-sm-4">
            {{ $t("title.tournament.condition") }}
          </div>
          <div class="col-sm-8 d-block">
            <div class="row row-cols-1 row-cols-sm-2 row-cols-xxl-4 gx-2 gy-3">
              <div class="col">
                <p class="mb-1 fw-500 fs-14">
                  {{ $t("title.common.level") }}
                </p>
                <select class="form-select-lg" v-model="form.level_fk">
                  <option v-for="n in 5" :key="'level' + n" :value="String(n)">
                    {{ $options.filters.levelType(String(n)) }}
                  </option>
                </select>
              </div>
              <!-- <div class="col">
                <p class="mb-1 fw-500 fs-14">
                  {{ $t("title.common.greenspeed") }}
                </p>
                <select class="form-select-lg" v-model="form.greenspeed_fk">
                  <option
                    v-for="n in 6"
                    :key="'greenspeed' + n"
                    :value="String(n)"
                  >
                    {{ $options.filters.greenspeed(String(n)) }}
                  </option>
                </select>
              </div>
              <div class="col">
                <p class="mb-1 fw-500 fs-14">
                  {{ $t("title.common.greengravity") }}
                </p>
                <select class="form-select-lg" v-model="form.greengravity_fk">
                  <option
                    v-for="n in 6"
                    :key="'greengravity' + n"
                    :value="String(n)"
                  >
                    {{ $options.filters.greengravity(String(n)) }}
                  </option>
                </select>
              </div> -->
            </div>
          </div>

          <div class="col-sm-4">
            {{ $t("title.common.status") }}
          </div>
          <div class="col-sm-8">
            <select class="form-select-lg" v-model="form.status">
              <option value="0">{{ $t("filter.common.ready") }}</option>
              <option value="1">{{ $t("filter.common.playing") }}</option>
              <option value="2">{{ $t("filter.common.completed") }}</option>
              <option value="3">{{ $t("filter.common.cancel") }}</option>
            </select>
          </div>
        </div>

        <div class="btn-bottom-wrapper">
          <b-button
            size="xl"
            variant="outline-primary"
            :aria-label="$t('button.common.list')"
            @click="$router.push({ name: 'MiniGameList' })"
            >{{ $t("button.common.list") }}</b-button
          >
          <b-button
            size="xl"
            variant="primary"
            type="submit"
            :aria-label="$t('button.common.save')"
            >{{ $t("button.common.save") }}</b-button
          >
        </div>
      </b-form>
    </div>

    <b-modal
      id="modal-event-invitational"
      size="xl"
      centered
      scrollable
      footer-class="btn-bottom-wrapper"
    >
      <template #modal-header>
        <h5 class="modal-title">
          {{ $t("title.tournament.invitational") }}
        </h5>
        <b-button
          variant="close"
          :aria-label="$t('button.common.close')"
          @click="$bvModal.hide('modal-event-invitational')"
        ></b-button>
      </template>

      <h6 class="modal-subtitle">
        {{ $t("text.common.invitation_list") }}
      </h6>
      <table class="table board table-sm">
        <thead>
          <tr>
            <th class="col-auto d-none d-lg-table-cell w-1">
              {{ $t("title.common.number") }}
            </th>
            <th class="col-auto">{{ $t("title.common.id") }}</th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.nickname") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.email") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.gender") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.favorite_location") }}
            </th>
            <th class="col-auto w-1">
              {{ $t("title.common.control") }}
            </th>
            <th class="th-arrow">&nbsp;</th>
          </tr>
        </thead>
        <tbody v-if="event_member_items.length > 0">
          <template v-for="(item, index) in event_member_items">
            <tr :key="'a' + index">
              <td class="col-auto d-none d-lg-table-cell w-1">
                {{ item.playerinfo.no }}
              </td>
              <td class="col-auto text-start text-lg-center">
                {{ item.playerinfo.id }}
              </td>
              <td class="col-auto d-none d-lg-table-cell text-start">
                <MemberInfo
                  :nickname="item.playerinfo.nickname"
                  :playerno="item.playerinfo.playerno"
                  :displayText="item.playerinfo.nickname"
                />
              </td>
              <td class="col-auto d-none d-lg-table-cell text-break text-start">
                {{ item.playerinfo.email }}
              </td>
              <td class="col-auto d-none d-lg-table-cell">
                {{
                  item.playerinfo.gender === "M"
                    ? $t("filter.common.male")
                    : $t("filter.common.female")
                }}
              </td>
              <td class="col-auto d-none d-lg-table-cell shop-name">
                <p
                  v-for="(shop, index_s) in item.shoplist"
                  :key="index_s + 's'"
                >
                  {{ shop.shopname }}
                </p>
              </td>
              <td class="col-auto w-1">
                <button
                  type="button"
                  class="btn btn-outline-secondary btn-xs"
                  @click="admineventplayerdrop(item.playerinfo.playerno)"
                >
                  {{ $t("button.common.delete") }}
                </button>
              </td>
              <td class="td-arrow" @click="toggle_tr(index)">
                <img
                  src="/img/arrow_none_collapsed.png"
                  :class="{ 'btn-toggle-arrow': view_hide === index }"
                />
              </td>
            </tr>
            <tr
              class="d-lg-none"
              :class="{ show: view_hide === index }"
              :key="index + 'r'"
              v-if="view_hide === index"
            >
              <td colspan="7">
                <div class="toggle-content">
                  <div class="row">
                    <div class="col-4">{{ $t("title.common.number") }}</div>
                    <div class="col-8">{{ item.playerinfo.no }}</div>
                  </div>
                  <div class="row">
                    <div class="col-4">
                      {{ $t("title.common.nickname") }}
                    </div>
                    <div class="col-8 py-0">
                      <MemberInfo
                        :nickname="item.playerinfo.nickname"
                        :playerno="item.playerinfo.playerno"
                        :displayText="item.playerinfo.nickname"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">{{ $t("title.common.email") }}</div>
                    <div class="col-8 text-break">
                      {{ item.playerinfo.email }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">{{ $t("title.common.gender") }}</div>
                    <div class="col-8">
                      {{
                        item.playerinfo.gender === "M"
                          ? $t("filter.common.male")
                          : $t("filter.common.female")
                      }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">
                      {{ $t("title.common.favorite_location") }}
                    </div>
                    <div class="col-8 shop-name">
                      <p
                        v-for="(shop, index_s) in item.shoplist"
                        :key="index_s + 's'"
                      >
                        {{ shop.shopname }}
                      </p>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="7" class="text-center">
              {{ $t("text.tournament.select_invite") }}
            </td>
          </tr>
        </tbody>
      </table>
      <!-- <b-pagination-nav
        :link-gen="linkGen2"
        :number-of-pages="member_page_total"
        v-model="searchData2.pageno"
        use-router
        :aria-label="$t('text.common.pagination')"
        v-if="member_page_total > 1"
        first-class="prev"
        prev-class="prev"
        next-class="next"
        last-class="next"
        hide-ellipsis
        limit="3"
      >
        <template #first-text
          ><i class="material-icons">keyboard_double_arrow_left</i></template
        >
        <template #prev-text
          ><i class="material-icons">navigate_before</i></template
        >
        <template #next-text
          ><i class="material-icons">navigate_next</i></template
        >
        <template #last-text
          ><i class="material-icons">keyboard_double_arrow_right</i></template
        >
        <template #page="{ page, active }">
          <div v-if="active">{{ page }}</div>
          <div v-else>{{ page }}</div>
        </template>
      </b-pagination-nav> -->

      <h6 class="modal-subtitle mt-5">
        {{ $t("text.common.member_list") }}
      </h6>
      <b-form @submit="onModalSubmit2" class="filter-group row g-2">
        <div class="col-12 col-md-auto">
          <select class="form-select-lg" v-model="searchData2.searchtype">
            <option value="P.nickname">
              {{ $t("filter.common.nickname") }}
            </option>
            <option value="P.email">
              {{ $t("filter.common.email") }}
            </option>
          </select>
        </div>

        <div class="col-12 col-md-auto">
          <div class="input-group">
            <input
              type="text"
              class="form-control form-control-lg"
              v-model="searchData2.searchname"
            />
            <button
              class="btn btn-primary btn-lg icon-search"
              type="submit"
              value=""
            ></button>
          </div>
        </div>
      </b-form>

      <table class="table board table-sm border-1">
        <thead>
          <tr>
            <th class="col-auto d-none d-lg-table-cell w-1">
              {{ $t("title.common.number") }}
            </th>
            <th class="col-auto">{{ $t("title.common.id") }}</th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.nickname") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.email") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.gender") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.favorite_location") }}
            </th>
            <th class="col-auto w-1">
              {{ $t("title.common.control") }}
            </th>
            <th class="th-arrow">&nbsp;</th>
          </tr>
        </thead>
        <tbody v-if="member_total_cnt">
          <template v-for="(item, index) in member_items">
            <tr :key="index + 'l2'">
              <td class="col-auto d-none d-lg-table-cell w-1">
                {{ item.playerinfo.no }}
              </td>
              <td class="col-auto text-start text-lg-center">
                {{ item.playerinfo.id }}
              </td>
              <td class="col-auto d-none d-lg-table-cell text-start">
                <MemberInfo
                  :nickname="item.playerinfo.nickname"
                  :playerno="item.playerinfo.playerno"
                  :displayText="item.playerinfo.nickname"
                />
              </td>
              <td class="col-auto d-none d-lg-table-cell text-break text-start">
                {{ item.playerinfo.email }}
              </td>
              <td class="col-auto d-none d-lg-table-cell">
                {{
                  item.playerinfo.gender === "M"
                    ? $t("filter.common.male")
                    : $t("filter.common.female")
                }}
              </td>
              <td class="col-auto d-none d-lg-table-cell shop-name">
                <p
                  v-for="(shop, index_s) in item.shoplist"
                  :key="index_s + 's'"
                >
                  {{ shop.shopname }}
                </p>
              </td>
              <td class="col-auto w-1">
                <button
                  type="button"
                  class="btn btn-xs"
                  :class="
                    event_member_items.some(
                      (v) => v.playerinfo.playerno === item.playerinfo.playerno
                    )
                      ? 'btn-primary'
                      : 'btn-outline-secondary'
                  "
                  @click="admineventplayerapply(item.playerinfo.playerno)"
                >
                  {{ $t("button.common.apply") }}
                </button>
              </td>
              <td class="td-arrow" @click="toggle_tr2(index)">
                <img
                  src="/img/arrow_none_collapsed.png"
                  :class="{ 'btn-toggle-arrow': view_hide2 === index }"
                />
              </td>
            </tr>
            <tr
              class="d-lg-none"
              :class="{ show: view_hide2 === index }"
              :key="index + 'r2'"
              v-if="view_hide2 === index"
            >
              <td colspan="7">
                <div class="toggle-content">
                  <div class="row">
                    <div class="col-4">{{ $t("title.common.number") }}</div>
                    <div class="col-8">{{ item.playerinfo.no }}</div>
                  </div>
                  <div class="row">
                    <div class="col-4">
                      {{ $t("title.common.nickname") }}
                    </div>
                    <div class="col-8 py-0">
                      <MemberInfo
                        :nickname="item.playerinfo.nickname"
                        :playerno="item.playerinfo.playerno"
                        :displayText="item.playerinfo.nickname"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">{{ $t("title.common.email") }}</div>
                    <div class="col-8 text-break">
                      {{ item.playerinfo.email }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">{{ $t("title.common.gender") }}</div>
                    <div class="col-8">
                      {{
                        item.playerinfo.gender === "M"
                          ? $t("filter.common.male")
                          : $t("filter.common.female")
                      }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">
                      {{ $t("title.common.favorite_location") }}
                    </div>
                    <div class="col-8 shop-name">
                      <p
                        v-for="(shop, index_s) in item.shoplist"
                        :key="index_s + 'm'"
                      >
                        {{ shop.shopname }}
                      </p>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="7" class="text-center">
              {{ $t("text.common.no_data") }}
            </td>
          </tr>
        </tbody>
      </table>
      <b-pagination-nav
        :link-gen="linkGen2"
        :number-of-pages="member_page_total"
        v-model="searchData2.pageno"
        use-router
        :aria-label="$t('text.common.pagination')"
        v-if="member_page_total > 1"
        first-class="prev"
        prev-class="prev"
        next-class="next"
        last-class="next"
        hide-ellipsis
        limit="3"
      >
        <template #first-text
          ><i class="material-icons">keyboard_double_arrow_left</i></template
        >
        <template #prev-text
          ><i class="material-icons">navigate_before</i></template
        >
        <template #next-text
          ><i class="material-icons">navigate_next</i></template
        >
        <template #last-text
          ><i class="material-icons">keyboard_double_arrow_right</i></template
        >
        <template #page="{ page, active }">
          <div v-if="active">{{ page }}</div>
          <div v-else>{{ page }}</div>
        </template>
      </b-pagination-nav>

      <template #modal-footer="{}">
        <b-button
          size="md"
          variant="primary"
          :aria-label="
            $t('text.common.invitation_list') +
            ' ' +
            $t('button.membership.excel_download')
          "
          @click="excelSave"
        >
          {{
            $t("text.common.invitation_list") +
            " " +
            $t("button.membership.excel_download")
          }}
        </b-button>
        <b-button
          size="md"
          variant="outline-secondary"
          :aria-label="$t('button.common.close')"
          @click="$bvModal.hide('modal-event-invitational')"
        >
          {{ $t("button.common.close") }}
        </b-button>
        <b-button
          size="md"
          variant="secondary"
          :aria-label="$t('button.common.save')"
          @click="admineventplayersave()"
        >
          {{ $t("button.common.apply") }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import "@/filter/common";
import ax from "@/api/event";

export default {
  name: "MiniGameWrite",
  data() {
    return {
      form: {
        shopno: 0,
        title: "",
        message: "",
        successmessage: "",
        point: "",
        startdate: "",
        enddate: "",
        systemrange: 0,
        type: 0,
        distance: 0,
        courseno: "",
        hole: "",
        isteebox: 1,
        teeboxman: 0,
        teeboxwoman: 0,
        level_fk: 3,
        gender: 0,
        greenspeed_fk: 0,
        greengravity_fk: 0,
        status: 0,
        rankno: 1,
        rankprizelist: [],
        entrylimit: 0,
        standard_point: false,
        oom_point: false,
        awardtype: "1",
      },
      eventno: this.$route.params.eventno || false,
      eventcourselist: [],
      courseview: { subcourse: [] },
      courseview_yn: "n",
      cc_par: [],
      eventshoplist: [],
      rank_count: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38,
        39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50,
      ],
      rows: 10,
      rows2: 5,
      rows3: 5,
      view_hide: null,
      view_hide2: null,
      view_hide3: null,
      member_total_cnt: 0,
      member_page_total: 1,
      member_items: [],
      event_member_page_total: 1,
      event_member_total_cnt: 0,
      event_member_items: [],
      searchData2: {
        searchtype: "P.nickname",
        searchname: "",
        pageno: 1,
      },
      searchData3: {
        pageno: 1,
      },
    };
  },
  methods: {
    toggle_tr(index) {
      this.view_hide = this.view_hide === index ? null : index;
    },
    toggle_tr2(index) {
      this.view_hide2 = this.view_hide2 === index ? null : index;
    },
    linkGen2(pageNum) {
      return `?page=${pageNum}`;
      // return pageNum === 1
      //   ? `?searchname=${this.searchData.searchname}&searchtype=${this.searchData.searchtype}`
      //   : `?page=${pageNum}&searchname=${this.searchData.searchname}&searchtype=${this.searchData.searchtype}`;
    },
    onModalSubmit2(event) {
      event.preventDefault();
      this.searchData2.pageno = 1;
      this.get_playerlist();
    },
    excelSave() {
      ax.excelSave(this.eventno, this.searchData3, (body) => {
        let tab_text =
          '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
        tab_text +=
          '<head><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">';
        tab_text +=
          "<xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
        tab_text += "<x:Name>Invitation List</x:Name>";
        tab_text +=
          "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
        tab_text += "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
        tab_text += "<table>";
        tab_text += body;
        tab_text += "</table></body></html>";

        var today = new Date();

        var year = today.getFullYear();
        var month = ("0" + (today.getMonth() + 1)).slice(-2);
        var day = ("0" + today.getDate()).slice(-2);

        var dateString = year + "-" + month + "-" + day;

        const fileName = "invitation".concat("_", dateString, ".xls");
        // const fileName = filename;
        const a_tag = document.createElement("a");
        const blob = new Blob([tab_text], {
          type: "application/vnd.ms-excel;charset=utf-8;",
        });
        a_tag.href = window.URL.createObjectURL(blob);
        a_tag.download = fileName;
        a_tag.click();
      });
    },
    admineventplayerapply(playerno) {
      if (
        this.event_member_items.some((v) => v.playerinfo.playerno === playerno)
      ) {
        alert(this.$i18n.t("alert.tournament.already_applied"));
        return false;
      }
      this.event_member_items = [
        ...this.event_member_items,
        this.member_items.find((v) => v.playerinfo.playerno === playerno),
      ];
    },
    admineventplayerdrop(playerno) {
      this.event_member_items = this.event_member_items.filter(
        (v) => v.playerinfo.playerno !== playerno
      );
    },
    admineventplayersave() {
      // if (this.shop_cnt < 1) {
      // alert(this.shop_cnt);
      ax.set_admineventplayersave(
        this.eventno,
        {
          player_pk: this.event_member_items.map((v) => v.playerinfo.playerno),
        },
        (flag, data) => {
          alert(data.message);
          // this.$bvModal.hide('modal-tournament-invitational');
          if (flag) {
            this.get_eventplayerlist();
          } else {
            return false;
          }
        }
      );
      // } else {
      //   alert("하나만 선택할 수 있습니다.");
      //   return false;
      // }
    },
    get_eventplayerlist() {
      ax.get_eventplayerlist(this.eventno, this.searchData3, (flag, data) => {
        if (flag) {
          this.event_member_total_cnt = data.eventplayerlistcnt;
          this.event_member_page_total = Math.ceil(
            data.eventplayerlistcnt / this.rows3
          );
          this.event_member_items = data.eventplayerlist;
        } else {
          this.member_page_total = 0;
          this.event_member_items = [];
          alert(data.message);
        }
      });
    },
    get_playerlist() {
      ax.get_playerlist(this.searchData2, (flag, data) => {
        if (flag) {
          this.member_total_cnt = data.playerlistcnt;
          this.member_page_total = Math.ceil(data.playerlistcnt / this.rows2);
          this.member_items = data.playerlist;
        } else {
          this.member_page_total = 0;
          this.member_items = [];
          alert(data.message);
        }
      });
    },
    invitational_modal() {
      this.searchData2.pageno = 1;
      this.get_eventplayerlist();
      this.get_playerlist();
      this.$bvModal.show("modal-event-invitational");
    },
    startDateChange(v) {
      this.form.startdate = v;
    },
    endDateChange(v) {
      this.form.enddate = v;
    },
    get_admineventcourselist() {
      ax.get_admineventcourselist((flag, data) => {
        if (flag) {
          this.eventcourselist = data.eventcourselist;
          //this.form.hole = ''
        } else {
          alert(data);
        }
      });
    },
    get_adminshoplist() {
      ax.get_adminshoplist((flag, data) => {
        if (flag) {
          this.eventshoplist = data.eventshoplist;
          //this.form.hole = ''
        } else {
          alert(data);
        }
      });
    },
    get_admincourseview() {
      ax.get_admincourseview(this.form.courseno, (flag, data) => {
        if (flag) {
          console.log(data.courseview);
          // alert(data.courseview[0].subcoursecnt)
          // alert(data.courseview[0].subcourse[0].subcoursename)
          this.courseview = data.courseview;
          this.subcoursecnt = data.courseview.subcourse.length;
          this.courseview.subcourse = data.courseview.subcourse;

          this.cc_par = [""];

          for (let i = 0; i < this.courseview.subcourse.length; i++) {
            this.courseview.subcourse.subcoursename =
              data.courseview.subcourse[i].title;
            // this.form.subcoursename = data.courseview[0].subcourse[i].subcoursename
            this.courseview.subcourse.subcoursehole =
              data.courseview.subcourse[i].subcoursehole;

            for (
              let j = 0;
              j < this.courseview.subcourse.subcoursehole.length;
              j++
            ) {
              this.cc_par.push(
                this.courseview.subcourse.subcoursehole[j].par_score
              );
            }
          }
        } else {
          alert(data.message);
        }
      });
    },
    onSubmit(event) {
      event.preventDefault();
      if (this.form.type > 10) {
        for (let i = 0; i < this.form.rankno; i++) {
          if (
            this.form.rankprizelist[i] === "" ||
            !this.form.rankprizelist[i]
          ) {
            alert(
              this.$i18n.t("alert.common.field_enter", {
                field: this.$i18n.t("title.common.prizes"),
              })
            );

            return false;
          }
        }
      }
      if (this.eventno) {
        ax.set_admineventedit(this.form, this.eventno, (flag, data) => {
          // console.log(flag, data);
          if (flag) {
            alert(data.message);
          } else {
            alert(data.message);
            return false;
          }
        });
      } else {
        ax.set_admineventwrite(this.form, (flag, data) => {
          // console.log(flag, data);
          if (flag) {
            alert(data.message);
            this.form.title = "";
            this.form.message = "";
            this.form.point = "";
            this.form.startdate = "";
            this.form.enddate = "";
            this.form.systemrange = 0;
            this.form.type = 0;
            this.form.entrylimit = 0;
            this.form.rankno = 1;
            this.form.rankprizelist = [];
            this.form.courseno = "";
            this.form.hole = "";
            this.form.isteebox = 1;
            this.form.teeboxman = "";
            this.form.teeboxwoman = "";
            this.form.gender = 0;
            this.form.status = "0";
            this.form.awardtype = "1";
          } else {
            alert(data.message);
            return false;
          }
        });
      }
    },
    // selecthole(subcourseno,event) {
    //   // this.subcourselistcnt= event.target.value
    //   // alert(event.target.name)
    //   // alert(subcourseno)
    // },
    get_admineventview() {
      ax.get_admineventview(this.eventno, (flag, data) => {
        console.log(flag, data);
        if (flag) {
          this.form = { ...this.form, ...data.eventinfo };
          this.form.startdate = this.$dayjs(this.form.startdate).format(
            "YYYY-MM-DD"
          );
          this.form.enddate = this.$dayjs(this.form.enddate).format(
            "YYYY-MM-DD"
          );

          this.form.rankno = data.awardprizerank.length
            ? data.awardprizerank.length
            : 1;
          data.awardprizerank.forEach((v) =>
            this.form.rankprizelist.push(v.prize)
          );

          this.form.standard_point =
            data.eventinfo.standard_point > 0 ? true : false;

          this.form.oom_point =
            data.eventinfo.oom_point > 0 ? true : false;

          this.courseview_yn = "y";
          this.get_admincourseview();
        } else {
          alert(data.message);
        }
      });
    },
    change_cc() {
      if (this.form.courseno !== "") {
        this.get_admincourseview();
        this.courseview_yn = "y";
      } else {
        this.courseview_yn = "n";
      }
      this.form.hole = "";
    },

    change_type() {
      this.form.hole = "";
      this.form.distance = 0;
    },

    click_hole(e) {
      let par_score = 0;
      let hole = e.target.value;
      console.log("this.form.hole", hole);
      par_score =
        this.courseview.subcourse.find(
          (v) => v.subcourseseq == hole.split("_").pop()
        ) &&
        this.courseview.subcourse
          .find((v) => v.subcourseseq == hole.split("_").pop())
          .subcoursehole.find((v) => v.hole_no == hole.split("_").shift()) &&
        this.courseview.subcourse
          .find((v) => v.subcourseseq == hole.split("_").pop())
          .subcoursehole.find((v) => v.hole_no == hole.split("_").shift())
          .par_score;
      console.log("par_score", par_score);
      if (this.form.type == "9" || this.form.type == "11") {
        if (par_score != "5" && par_score != "4") {
          alert(this.$i18n.t("alert.event.longest_only_on_par4_or_par5"));
          e.target.checked = false;
        }
      }

      if (this.form.type == "10" || this.form.type == "12") {
        if (par_score != "3") {
          alert(this.$i18n.t("alert.event.nearpins_only_on_par3"));
          e.target.checked = false;
        }
      }
    },
  },

  created() {
    if (this.eventno) {
      this.get_admineventview();
    }
    this.get_admineventcourselist();
    this.get_adminshoplist();
  },
  watch: {
    "form.type": function (newVal, oldVal) {
      // this.form.hole = "";
    },
    "$route.query.page": function () {
      this.searchData2.pageno = parseInt(this.$route.query.page) || 1;
      this.get_playerlist();
    },
    "$route.query.page3": function () {
      this.searchData3.pageno = parseInt(this.$route.query.page3) || 1;
      this.get_eventplayerlist();
    },

    "searchData2.searchtype": function () {
      this.searchData2.pageno = 1;
      this.get_playerlist();
    },
    "searchData2.searchname": function () {
      this.searchData2.pageno = 1;
      this.get_playerlist();
    },
  },
};
</script>
